export function ContributionPrinciples({ compact = false }: { compact?: boolean }) {
  return <section className={compact ? 'contribution-principles compact' : 'contribution-principles page-section'}>
    <span className="eyebrow dark">Our guiding principle · The Three T’s</span>
    <h2>Time. Talent. Treasure.</h2>
    <p className="lead">Give what you can, when you can, in whatever amounts and combinations you can.</p>
    <div className="three-ts-grid">
      <article><h3>Time</h3><p>Your presence, helping hands, and willingness to show up for others.</p></article>
      <article><h3>Talent</h3><p>Your skills, creativity, knowledge, and the gifts you can share.</p></article>
      <article><h3>Treasure</h3><p>The money, materials, or resources you can contribute.</p></article>
    </div>
    <p>These principles reach beyond Ourrenland—to our community and any group, organization, or society we help build. When everyone contributes what they can, together our guild can soar to even greater heights.</p>
  </section>
}
